@let menuItem = item();
@if (menuItem) {
  <div class="button-grid-item">
    @if (showTitleOnTop()) {
      @if (menuItem.title) {
        <div class="top-title">
          {{ menuItem.title }}
        </div>
      }
    }
    <div
      class="button-grid-link"
      [ngStyle]="buttonStyles()"
      [ngClass]="buttonClasses()"
    >
      @if (menuItem.playable) {
        <a (click)="playEvent($event)" href="#" class="play-button">
          <fa-icon class="play-icon" [icon]="faPlay"></fa-icon>
        </a>
      } @else {
        <div class="top-link" (click)="clickEvent($event)"></div>
      }
      @if (!nameOnBottom()) {
        <a
          [routerLink]="menuItem.routerLink ?? ''"
          (click)="clickEvent($event)"
          class="button-name"
        >
          <div class="name-text">
            {{ menuItem.name }}
          </div>
        </a>
      }
    </div>
    @if (nameOnBottom()) {
      <div class="bottom-name">
        <a
          [routerLink]="menuItem.routerLink ?? ''"
          (click)="clickEvent($event)"
          class="button-name"
        >
          <div class="name-text bottom-name">
            {{ menuItem.name }}
          </div>
        </a>
      </div>
    } @else if (showTagLine() && menuItem.tagLine) {
      <div class="bottom-desc">
        {{ menuItem.tagLine }}
      </div>
    }
  </div>
}
